var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83318 0.708374C4.17836 0.708374 4.45818 0.988196 4.45818 1.33337V2.72306C6.81463 2.51321 9.18507 2.51321 11.5415 2.72307V1.33337C11.5415 0.988196 11.8213 0.708374 12.1665 0.708374C12.5117 0.708374 12.7915 0.988196 12.7915 1.33337V2.84707C14.0357 3.02299 15.0187 4.0071 15.185 5.2624L15.2572 5.80653C15.5605 8.09514 15.5343 10.4154 15.1794 12.6966C15.0035 13.8266 14.0855 14.6946 12.9474 14.8068L11.9532 14.9049C9.32399 15.1641 6.67566 15.1641 4.04645 14.9049L3.05228 14.8068C1.91416 14.6946 0.996115 13.8266 0.820274 12.6966C0.465309 10.4154 0.439108 8.09514 0.742471 5.80653L0.814597 5.2624C0.980994 4.00708 1.96395 3.02297 3.20818 2.84706V1.33337C3.20818 0.988196 3.488 0.708374 3.83318 0.708374ZM4.20415 4.00238C6.72847 3.75344 9.27117 3.75344 11.7955 4.00238L12.55 4.07679C13.2723 4.14802 13.8505 4.70716 13.9459 5.42666L14.018 5.97079C14.0432 6.16088 14.066 6.3512 14.0864 6.54171H1.91323C1.93363 6.3512 1.95643 6.16088 1.98163 5.97079L2.05376 5.42666C2.14913 4.70716 2.72732 4.14802 3.44961 4.07679L4.20415 4.00238ZM1.81387 7.79171C1.73206 9.3651 1.81266 10.9444 2.05541 12.5044C2.14361 13.0712 2.60409 13.5066 3.17496 13.5629L4.16913 13.6609C6.71675 13.9121 9.2829 13.9121 11.8305 13.6609L12.8247 13.5629C13.3956 13.5066 13.856 13.0712 13.9442 12.5044C14.187 10.9444 14.2676 9.3651 14.1858 7.79171H1.81387Z",
    fill: "#04D9FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.cf1f9fcaaffa0be84bb68022da2e0f27.svg";
export { ForwardRef as ReactComponent };